module.exports = __webpack_public_path__ + "media/images/icon-textbook-03aac0ca.png";